import * as types from '../actions/types';

// Режим «Документы об образовании».
// Статус загрузки и код отказа лежат рядом с данными, но отдельными полями:
// отказ сервера должен рисовать блок ошибки, а не «данных нет».
const initialState = {
  list: null,
  count: 0,
  isLoading: false,
  errorStatus: null,

  docTypes: [],
  counerType: [],
  yearsType: [],

  filesList: [],
  filesIsLoading: false,
  filesErrorStatus: null,
};

export default function document(state = initialState, action) {
  switch (action.type) {
    case types.DOCUMENT_LIST_STARTED:
      return {
        ...state,
        isLoading: true,
        errorStatus: null,
      };

    case types.DOCUMENT_LIST_COMPLETED:
      return {
        ...state,
        list: action.list,
        count: action.count,
        isLoading: false,
        errorStatus: null,
      };

    // флаг загрузки снимается и здесь, иначе спиннер зависает
    case types.DOCUMENT_LIST_FAILED:
      return {
        ...state,
        list: null,
        count: 0,
        isLoading: false,
        errorStatus: action.errorStatus,
      };

    case types.DOCUMENT_CLEAR:
      return initialState;

    case types.DOCUMENT_TYPES:
      return {
        ...state,
        docTypes: action.payload,
      };

    case types.COUNER_TYPES:
      return {
        ...state,
        counerType: action.payload,
      };

    case types.YEARS_TYPES:
      return {
        ...state,
        yearsType: action.payload,
      };

    case types.FILES_LIST_STARTED:
      return {
        ...state,
        filesList: [],
        filesIsLoading: true,
        filesErrorStatus: null,
      };

    case types.FILES_LIST_COMPLETED:
      return {
        ...state,
        filesList: action.payload,
        filesIsLoading: false,
        filesErrorStatus: null,
      };

    case types.FILES_LIST_FAILED:
      return {
        ...state,
        filesList: [],
        filesIsLoading: false,
        filesErrorStatus: action.errorStatus,
      };

    default:
      return state;
  }
}
